import _ from 'lodash';
import { TEMPLATE_GAIN_RATIO } from '@/widgets/beats/ui/reviewBeatsHelper';
import TemplatePreview from '@/widgets/beats/ui/templatePreview';
import useSwapTemplateModal from './useSwapTemplateModal';
import './styles.scss';

export type SwapTemplateModalProps = {
  isSwapAllTemplate?: boolean;

  isSwapAllTemplateById?: boolean;
  isOpen?: boolean;
};

/**
 * Renders the swap-template modal listing every merged beat morphology template with a small waveform preview and a Swap button. Maps mergeTemplateList from useSwapTemplateModal into preview-only TemplatePreview cards with status hidden, calls onClickSwapTemplate with the chosen template and closes through onCloseModal.
 *
 * @param props - Modal inputs including the open flag and which swap mode, by page or by id, was requested.
 * @returns The swap template modal with its template grid and cancel footer.
 */
const SwapTemplateModal = ({
  isSwapAllTemplate,
  isSwapAllTemplateById,
  isOpen,
}: SwapTemplateModalProps) => {
  const { mergeTemplateList, ecgDataMap, onClickSwapTemplate, onCloseModal } = useSwapTemplateModal(
    { isSwapAllTemplate, isSwapAllTemplateById, isOpen },
  );

  return (
    <div className="swap-template-modal">
      <div className="draggable-modal-content">
        <div className="content-title">Swap template</div>
        <div className="content">
          <div className="swap-template-container">
            {_.map(mergeTemplateList, (x) => (
              <div className="swap-template-wrapper">
                <div className="swap-template-button">
                  <div className="swap-template-button__container">
                    <button
                      id={`beats-swap-template-btn-${x.id}`}
                      onClick={() => onClickSwapTemplate(x)}
                    >
                      Swap
                    </button>
                  </div>
                </div>
                <TemplatePreview
                  template={x}
                  isUnclassified={x.unclassified}
                  name={x.name}
                  beatCount={x.total}
                  isSmallSize
                  ecgDataMap={ecgDataMap}
                  isIncluded={x.isIncludedToReport}
                  gain={7.5 * TEMPLATE_GAIN_RATIO.SMALL_SIZE}
                  id={`swap-template-modal-${x.id}`}
                  hideStatus
                  // preview-only here - swapping happens via the "Swap" button above,
                  // and hideStatus=true means selectedTemplate/*BeatsChanges are never read.
                  onClickSelect={() => {}}
                  selectedTemplate={undefined}
                  reviewedBeatsChanges={[]}
                  bulkReviewedBeats={[]}
                  resetBulkReviewedBeats={[]}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="footer-btn">
        <button
          id="beats-swap-template-cancel-btn"
          className="draggable-modal-btn"
          onClick={onCloseModal}
        >
          Cancel (ESC)
        </button>
      </div>
    </div>
  );
};

export default SwapTemplateModal;
